import { render, staticRenderFns } from "./DashboardDfe.vue?vue&type=template&id=22e967ac&scoped=true&"
import script from "./DashboardDfe.vue?vue&type=script&lang=js&"
export * from "./DashboardDfe.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDfe.vue?vue&type=style&index=0&id=22e967ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e967ac",
  null
  
)

export default component.exports